import React from 'react';
import '../Steps.scss';
import { StepHeader } from './Header';
import { StepControls } from './Controls';
import { StepProps } from '../Steps';
import secondStepImage from './TourImages/secondStep.jpg';

export const SecondStep = (props: StepProps) => {
  return (
    <div className="step-container second-step">
      <StepHeader {...props} />
      <div className="step-container__title">
        A user-friendly Inbox that identifies the most important conversations
        on any chat platform:
      </div>
      <div className="step-container__description-image-container">
        <img
          className="step-container__description-image"
          src={secondStepImage}
        />
      </div>
      <StepControls {...props} />
    </div>
  );
};
